export default "__VITE_ASSET__80e552ae__"